/**
 * Created by administrator on 2017/3/29.
 */
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import exportFnDialog from 'exportFnDialog';

export default {
    components: {
        exportFnDialog
    },
    data() {
        return {
            selType: 1
        }
    },
    methods: {
        showExportDialog(type) {
            this.selType = type;
            this.$refs.refExportFnDialog.show({
                type: this.selType
            });
        }
    },
    watch: {
        '$route' (to, from) {
            if (this.$route.path == '/exportFunction/exportOrderAndStockoutOrder') {}
        }
    },
    created() {

    }

}


// WEBPACK FOOTER //
// ./src/pages/exportFunction/exportOrderAndStockoutOrder/vm.js